import { TObject } from 'models';
import {
  Color,
  Bitmask, createBitmask,
  toCamelCaseObject, toSnakeCaseObject
} from 'utils';

export interface Condition {
  objectId?: string;
  objectName?: string;
  objectColorRgb?: Color;
  id: string;
  name?: string;
  colorRgb?: Color;
  isEnabled: boolean;
}

export function parseCondition(a: any): Condition {
  let obj = toCamelCaseObject(a);
  if (obj.objectColorRgb) {
    obj.objectColorRgb = new Color(obj.objectColorRgb as number)
  }
  if (obj.colorRgb) {
    obj.colorRgb = new Color(obj.colorRgb as number)
  }
  return obj as Condition;
}

export function parseConditions(arr: any[]): Condition[] {
  return arr?.map(a => parseCondition(a));
}
